import ActivityBodyInfo from "./ActivityBodyInfo";

export default ActivityBodyInfo;
